import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Unknown error" };
  }

  componentDidCatch(error, info) {
    console.error("UI crash:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tt-boot">
          <div className="tt-card" style={{ maxWidth: 420, textAlign: "center" }}>
            <h2>Something went wrong</h2>
            <p className="tt-muted">{this.state.message}</p>
            <button
              className="tt-btn"
              onClick={() => {
                localStorage.removeItem("tabletstalk_token");
                localStorage.removeItem("tabletstalk_user");
                window.location.href = "/";
              }}
            >
              Reset & go home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
